import template from './auth.html';
import {AuthController} from './auth.controller.js';

const AuthComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: AuthController,
    controllerAs: 'vm'
};

export {AuthComponent};



// WEBPACK FOOTER //
// ./app/components/auth/auth.component.js